<template>
  <div class="quick-sign-in-content-one-container">
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="vp-pos-absolute vp-left-406 vp-top--8"
      @click="$bvModal.hide('quickSignIn')"
    >
      <path
        d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
        fill="#F46A6A"
      />
    </svg>

    <p
      class="vp-font-weight-700 vp-font-size-17 text-center line-height-20_4 vp-mb-24 vp-height-12"
    >
      {{ $t('users.form.quickSignin') }}
    </p>
    <p
      class="vp-font-weight-700 vp-font-size-16 text-center line-height-19_2 vp-mb-40 vp-color-grey-2 vp-height-12"
    >
      {{ $t('signInOut.userDetails') }}
    </p>

    <!-- start:: user form tab-->
    <user-form :showCloseIcon="false">
      <template #content>
        <!-- start:: full name multiselect -->
        <VpMultiselect
          class="available-users-multiselect"
          :showPlaceholderIcon="true"
          :showOptionsBorder="true"
          :showNoResults="true"
          :allowEmpty="true"
          :show-labels="false"
          :searchable="true"
          :isLoading="fetchingUsers"
          track-by="id"
          :label="userSearchLabel"
          :options="matchedUsers"
          width="416"
          :title="userFullNameMultiselectTitle"
          dropDownStyle="relative"
          :placeholder="$t('addExpectedVisitor.searchByNamePhoneNumberEmail')"
          noResultMessage="List is empty."
          @searchChange="searchUser"
          v-model="user.fullName"
        />
        <!-- end:: full name multiselect -->

        <template v-if="isNewUser">
          <!-- start:: first name -->
          <VpInput
            :label="$t('common.firstName')"
            v-model="$v.user.firstName.$model"
            width="416"
            maxlength="20"
            :class="{ 'cursor-stop': $v.user.firstName.$model.length > 20 }"
          />
          <!-- end: first name -->

          <!-- start:: last name -->
          <VpInput
          :label="$t('common.lastName')"
            v-model.trim="$v.user.lastName.$model"
            width="416"
            maxlength="20"
            :class="{ 'cursor-stop': $v.user.firstName.$model.length > 20 }"
          />
          <!-- end:: last name -->

          <!-- start:: user type -->
          <VpTreeselect
            :isLoading="userTypesLoading"
            :disabled="userTypesLoading"
            class="user-type-treeselect"
            zIndex="10"
            :showPlaceholderIcon="true"
            width="416"
            :showOptionsBorder="true"
            :showNoResults="true"
            :allowEmpty="true"
            :show-labels="true"
            :isMultiple="false"
            :label="$t('common.userType')"
            dropDownStyle="relative"
            noResultMessage="No results found"
            v-model="$v.user.userType.$model"
            :options="userTypes"
          />
          <!-- end:: user type -->

          <!-- start:: email -->
          <VpInput
            type="text"
            width="416"
            :label="`${$t('common.email')} (${$t('common.optional')})`"
            v-model.trim="$v.user.email.$model"
            @input="checkDuplicateEmail"
            :invalid="
              isDuplicateEmail || ($v.user.email.$invalid && isEmailBlurred)
            "
            :errMsg="emailErrorMessage"
            :isLoading="emailCheckLoading"
            @blur="isEmailBlurred = true"
            @focus="isEmailBlurred = false"
          />
          <!-- end:: email -->

          <!-- start::phone number -->
          <div
            :class="{
              'vp-mt-45':
                isDuplicateEmail || ($v.user.email.$invalid && isEmailBlurred),
            }"
          >
            <div class="d-flex justify-content-between vp-width-416">
              <VueCountryCode
                class="country-code-input"
                :disabledFetchingCountry="false"
                :enabledCountryCode="true"
                :preferredCountries="['GB', 'US', 'CN']"
                @onSelect="onSelectUserCountryCode"
                v-model="user.countryCode"
              />

              <VpInput
                type="number"
                :label="$t('common.phoneNumberOptional')"
                width="285"
                v-model="$v.user.phoneNumber.$model"
                @input="checkDuplicatePhoneNumber"
                :invalid="
                  isDuplicatePhoneNumber || $v.user.phoneNumber.$invalid
                "
                :errMsg="phoneErrorMessage"
                :isLoading="phoneCheckLoading"
                :class="{
                  'vp-mb-45':
                    isDuplicatePhoneNumber || $v.user.phoneNumber.$invalid,
                }"
              />
            </div>
          </div>
        </template>
        <!-- end:: phone number -->
      </template>
    </user-form>
  </div>
</template>
<script>
import visitService from "@/services/visit.js";
import UserForm from "@/components/sharedComponents/form/FormModal.vue";
import VueCountryCode from "vue-country-code";
import userTypeService from "@/services/userType";
import userService from "@/services/users";
import { requiredIf, email, numeric } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { debounce } from "lodash";

export default {
  components: { UserForm, VueCountryCode },
  validations: {
    user: {
      firstName: {
        required: requiredIf(function () {
          return this.isNewUser;
        }),
      },
      lastName: {
        required: requiredIf(function () {
          return this.isNewUser;
        }),
      },
      userType: {
        required: requiredIf(function () {
          return this.isNewUser;
        }),
      },
      email: {
        email,
      },
      phoneNumber: {
        numeric,
      },
      fullName: {
        required: requiredIf(function () {
          return !this.isNewUser;
        }),
      },
    },
  },
  watch: {
    "$v.user": {
      handler() {
        this.$emit(
          "isUserFormInvalid",
          this.isDuplicateEmail ||
            this.isDuplicatePhoneNumber ||
            this.$v.user.$invalid
        );
        this.$emit("newUserInfo", this.$v.user.$model);
        this.$emit("setUserDetails", this.user.fullName);
      },
      deep: true,
    },
    emailCheckLoading() {
      this.$emit("apiChecksLoading", this.emailCheckLoading);
    },
    phoneCheckLoading() {
      this.$emit("apiChecksLoading", this.phoneCheckLoading);
    },
    isNewUser() {
      this.$emit("setIsNewUser", this.isNewUser);
    },
  },
  computed: {
    ...mapGetters("authfack", ["currentEntity"]),
    emailErrorMessage() {
      let errorMessage = "";

      // Check if the email is invalid or duplicated
      if (this.$v.user.email.$invalid || this.isDuplicateEmail) {
        // Use a ternary operator for conciseness
        errorMessage = this.$v.user.email.$invalid
          ? "Email must be a valid email."
          : "Email address already exists, register with a different one.";
      }

      return errorMessage;
    },
    phoneErrorMessage() {
      let errorMessage = "";

      // Check if the phone is invalid or duplicated
      if (this.$v.user.phoneNumber.$invalid || this.isDuplicatePhoneNumber) {
        // Use a ternary operator for conciseness
        errorMessage = this.$v.user.phoneNumber.$invalid
          ? "Phone must be a valid number."
          : "Phone number already exists, register with a different one.";
      }

      return errorMessage;
    },
    userFullNameMultiselectTitle() {
      let titleVal = "Name";
      switch (this.userSearchLabel) {
        case "userName_with_userType":
          titleVal = this.$t("common.name");
          break;
        case "email":
          titleVal = this.$t("common.email");
          break;
        case "phone":
          titleVal = this.$t("common.phone");
          break;
      }
      return titleVal;
    },
  },
  data() {
    return {
      regEmail:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      userLoading: false,
      userTypes: [],
      userTypesLoading: true,
      isNewUser: false,
      isDuplicateEmail: false,
      emailCheckLoading: null,
      isDuplicatePhoneNumber: false,
      phoneCheckLoading: null,
      matchedUsers: [],
      fetchingUsers: false,
      isEmailBlurred: false,
      user: {
        firstName: "",
        lastName: "",
        fullName: null,
        userType: null,
        email: null,
        countryCode: null,
        phoneNumber: null,
      },
      userSearchLabel: "userName_with_userType",
    };
  },
  methods: {
    async searchByUserName(value) {
      if (value?.length < 3) return;

      try {
        this.fetchingUsers = true;

        let checkStringIsEmail = this.validateEmail(value);
        if (checkStringIsEmail) this.userSearchLabel = "email";
        else if (!isNaN(value)) this.userSearchLabel = "phone";
        else this.userSearchLabel = "userName_with_userType";

        const { data: matchedUsers } = await userService.searchUserInEntity(
          value
        );
        if (Array.isArray(matchedUsers) && matchedUsers.length) {
          // this.compkey++;
          this.matchedUsers = matchedUsers;
          this.isNewUser = false;
          this.isDuplicateEmail = false;
          this.isDuplicatePhoneNumber = false;
          this.user = {
            firstName: "",
            lastName: "",
            userType: null,
            email: null,
            countryCode: null,
            phoneNumber: null,
          };
        } else {
          this.matchedUsers = [];
          this.isNewUser = true;
          this.user.fullName = null;
          value = value.trim();
          let [firstName, ...lastName] = value.split(" ");
          lastName = lastName.join(" ");
          this.user.firstName = firstName.substr(0, 20);
          this.user.lastName = lastName.substr(0, 20);
          if(this.userTypes?.length == 1) 
            this.user.userType = this.userTypes[0].id
        }
      } catch (error) {
        console.error("Could not fetch users ", error);
      } finally {
        this.fetchingUsers = false;
      }
    },
    validateEmail(email) {
      let isEmailForm = false;
      if (this.regEmail.test(email)) {
        isEmailForm = true;
      }
      return isEmailForm;
    },
    onSelectUserCountryCode({ dialCode }) {
      this.user.countryCode = dialCode;
    },
    async checkDuplicateEmail(value) {
      this.isDuplicateEmail = false;

      if (this.$v.user.email.$invalid || !value) return;

      this.emailCheckLoading = true;

      let formData = new FormData();
      formData.append("entity_id", this.currentEntity.id);
      formData.append("user_id", "");
      formData.append("field", "email");
      formData.append("value", value);

      try {
        const {
          data: { available: isEmailAvailable },
        } = await visitService.getUsersByEmailOrPhone(formData);
        this.isDuplicateEmail = !isEmailAvailable;
      } catch (error) {
        console.error("Could not fetch email availability ", error);
      } finally {
        this.emailCheckLoading = false;
        this.$emit("isUserFormInvalid",this.isDuplicateEmail ||
            this.isDuplicatePhoneNumber ||
            this.$v.user.$invalid)
      }
    },
    async checkDuplicatePhoneNumber(value) {
      this.isDuplicatePhoneNumber = false;

      if (!value) return;

      this.phoneCheckLoading = true;

      let formData = new FormData();
      formData.append("entity_id", this.currentEntity.id);
      formData.append("user_id", "");
      formData.append("field", "phone");
      formData.append("value", value);

      try {
        const {
          data: { available: isPhoneAvailable },
        } = await visitService.getUsersByEmailOrPhone(formData);
        this.isDuplicatePhoneNumber = !isPhoneAvailable;
      } catch (error) {
        console.error("Could not fetch phone availability ", error);
      } finally {
        this.phoneCheckLoading = false;
        this.$emit("isUserFormInvalid",this.isDuplicateEmail ||
            this.isDuplicatePhoneNumber ||
            this.$v.user.$invalid)
      }
    },
    checkDuplicationData(type) {
      let value = "";
      this.phoneLoading = false;
      this.emailCheckLoading = false;
      this.submitted = true;

      if (type == "email") {
        this.validEmailMessage = false;
        this.emailCheckLoading = true;
        this.emailErrorMessage = false;
        value = this.form.user.email;
      } else if (type == "phone") {
        this.phoneLoading = true;
        this.phoneErrorMessage = false;
        value = this.userPhone ? this.userCountryCode + this.userPhone : "";
      }

      // console.log('value', value);

      if (type && value && value.length > 0) {
        if (type == "email") {
          let checkStringIsEmail = this.validateEmail(value);
          if (!checkStringIsEmail) {
            this.validEmailMessage = true;
            this.emailCheckLoading = false;
            return;
          }
        }
        let formData = new FormData();
        formData.append("entity_id", this.currentEntity.id);
        formData.append("user_id", this.form.user.id ? this.form.user.id : "");
        formData.append("field", type);
        formData.append("value", value);
        setTimeout(async () => {
          await this.fetchUsersByEmailOrPhone(formData).then((data) => {
            if (!data.data.available) {
              if (data.data.field == "email") {
                this.emailErrorMessage = true;
              } else if (data.data.field == "phone") {
                this.phoneErrorMessage = true;
              }
              if (data.data.field == "user_user_id") {
                this.duplicateUserIdGenerated = false;
                this.userIdErrorMessage = true;
              }
            }
            this.emailCheckLoading = false;
            this.phoneLoading = false;
            this.userIdLoading = false;
            this.submitted = false;
          });
        }, 2000);
      } else {
        this.phoneLoading = false;
        this.emailCheckLoading = false;
        this.userIdLoading = false;
        this.submitted = false;
      }
    },
  },
  async beforeMount() {
    this.$v.user.$touch()
    try {
      const { data } = await userTypeService.getPermittedUserTypes();

      if (data.length == 1) this.user.userType = data[0]?.id;

      data?.forEach((item) => {
        if (!item?.children?.length) delete item.children;
        this.userTypes.push(item);
      });
    } catch (error) {
      console.error("Failed to fetch user types:", error);
    } finally {
      this.userTypesLoading = false;
    }
  },
  created() {
    this.searchUser = debounce(this.searchByUserName.bind(this), 500);
  },
};
</script>

<style lang="scss">
.quick-sign-in-content-one-container {
  .country-code-input {
    width: 110px;
    height: 55px;
    background-color: #f2f2f2;
    border-radius: 4px !important;
    border: none;
    z-index: 1 !important;
    .is-invalid {
      border: 1.5px solid #f46a6a !important;
      border-radius: 4px;
    }
  }
  .vue-treeselect__menu {
    //max-height: 172px !important;
    padding-top: 0;
    top: 0 !important;
    .vue-treeselect__label {
      padding-bottom: 7px !important;
      padding-top: 8px !important;
    }
  }
  .multiselect__content-wrapper,
  .multiselect__content {
    max-height: 178px !important;
  }
  .multiselect__content-wrapper .multiselect__content li{
    height:44px !important;
  }

  .vue-country-select.country-code-input {
    .current {
      font-size: 16px;
      font-weight: 400;
      line-height: 19.2px;
      letter-spacing: 0.25px;
    }
  }
}
</style>
